import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function Spin({ loading, invisible }) {
  return (
    <div>
      <Backdrop
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: "#fff",
        }}
        open={loading}
        invisible={!invisible ? false : invisible}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
